module.exports = __webpack_public_path__ + "img/light-logo.118ee3fa.png";